import React, { useState } from 'react';
import './Modal.css';
import ReactDOM from 'react-dom';

export default function Modal({ open, children, toggleModal, overlayType }) {
  if (!open) return null;
  return ReactDOM.createPortal(
    <div className='modal-wrapper'>
      <div
        className='overlay'
        onClick={overlayType === 'unclickable' ? null : toggleModal}></div>
      <div className='modal-content-wrapper'>{children}</div>
    </div>,
    document.getElementById('portal')
  );
}
